import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SpecialInvestmentPaymentScheduleTab } from '../../models/_enum-collections';
import { CommonSharedModule } from '../common/shared.module';
import { PaymentScheduleMilestone1Component } from './payment-schedule-milestone1/payment-schedule-milestone1.component';
import { PaymentScheduleMilestone2Component } from './payment-schedule-milestone2/payment-schedule-milestone2.component';

@Component({
  selector: 'app-payment-schedule',
  templateUrl: './payment-schedule.component.html',
  styleUrls: ['./payment-schedule.component.scss'],
  standalone: true,
  imports: [
    CommonSharedModule,
    PaymentScheduleMilestone1Component,
    PaymentScheduleMilestone2Component
  ]
})
export class PaymentScheduleComponent implements OnInit {
  tabList!: PaymentScheduleTabDetailsModel[];

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.tabList = [
      new PaymentScheduleTabDetailsModel(true, true),
      new PaymentScheduleTabDetailsModel()
    ];

    const tabName = this.route.snapshot.queryParamMap.get('tab');
    const tabSelected = tabName as SpecialInvestmentPaymentScheduleTab;
    if (tabSelected === SpecialInvestmentPaymentScheduleTab.Milestone2) {
      this.tabList[0].isTabSelected = false;
      this.tabList[0].hasTabLoaded = false;

      this.tabList[1].isTabSelected = true;
      this.tabList[1].hasTabLoaded = true;
    } else {
      this.tabList[0].isTabSelected = true;
      this.tabList[0].hasTabLoaded = true;

      this.tabList[1].isTabSelected = false;
      this.tabList[1].hasTabLoaded = false;
    }
  }

  get isMilestone1Selected(): boolean {
    return this.tabList[0].isTabSelected;
  }

  onTabChange(event) {
    this.tabList.forEach(tab => {
      tab.isTabSelected = false;
    });
    this.tabList[event.index].hasTabLoaded = true;
    this.tabList[event.index].isTabSelected = true;
  }
}

export class PaymentScheduleTabDetailsModel {
  public hasTabLoaded: boolean;
  public isTabSelected: boolean;
  constructor(hasTabLoaded = false, isTabSelected = false) {
    this.hasTabLoaded = hasTabLoaded;
    this.isTabSelected = isTabSelected;
  }
}
